import { Observable } from 'rxjs';

import { ISnMapQueryParams, ISnListQueryParameters } from '@lib/api';
import { SnAlarm, SnCamera, SnFloor, SnLocation, SnTags } from '@lib/api/entities';

export interface LocationMapQueryParams extends ISnMapQueryParams {
  pageMapGridSize: number;
  pageMapClustered: boolean;
  pageMapZoomLevel: number;
  pageMapLeftTop: string;
  pageMapRightBottom: string;
}

export interface LocationQueryParams {
  bounds: {
    leftTop: { lat: number; lng: number };
    rightBottom: { lat: number; lng: number };
  };
  zoom: number;
  maxZoom: number;
}

export interface LocationsServiceInterface {
  selectionChange$: Observable<SnLocation | null>;
  selectedFloor$: Observable<SnFloor | null>;
  cameraSelected$: Observable<SnCamera>;
  cameraTags$: Observable<SnTags>;
  removePolyline$: Observable<void>;
  hovered$: Observable<SnCamera | null>;
  sdsFloorCameras$: Observable<SnCamera[]>;
  selectedFloorHasCameras$: Observable<boolean>;
  roomsCleared$: Observable<void>;
  roomsClearedReset$: Observable<void>;

  selected: SnLocation | null;
  selectedFloor: SnFloor | null;
  selectedNumCameras: number;
  selectedFloorHasCameras: boolean;
  roomFullyCleared: boolean;
  isRoomClearingEnabled: boolean;

  isSelected(locationId: string): boolean;
  selectLocation(
    id: string,
    data?: SnAlarm,
    move?: boolean,
    keepAlarmPopup?: boolean,
  ): Observable<SnLocation>;
  deselectLocation(): void;
  getNearestLocationForSDS(alarm: SnAlarm): Observable<SnLocation | null>;
  fetchLocationData(
    params: LocationQueryParams,
  ): Observable<{ results: SnLocation[]; clusterResults: any[] }>;
  loadCameraLocation(locationId: string, floorId?: string): Observable<SnCamera[]>;
  loadFloorPanoramas(locationId: string, floorId?: string): Observable<any[]>;
  findAndSetFloorMatch(location: SnLocation, alarm: SnAlarm): Observable<SnFloor | null>;
  clearAllRooms(locationId?: string, floorId?: string): Observable<void>;
  removeClearAllRooms(locationId?: string, floorId?: string): Observable<void>;
  clearRoom(
    locationId: string,
    floorId: string,
    coords: { lon: number; lat: number },
  ): Observable<void>;
  removeClearRoom(locationId: string, floorId: string, roomId: string): Observable<void>;
  getFloor(locationId: string, floorId: string): Observable<SnFloor>;
  onCameraClick(cameraId: string): Observable<SnCamera>;
  onCameraRightClick(cameraId: string): Observable<SnCamera>;
}
